import { ColumnMapping, ParsedExcelData } from './types';

export const parseExcelData = (columnMapping: Record<string, ColumnMapping>, dataRows: any[][]): ParsedExcelData => {
  const result: ParsedExcelData = {};

  Object.values(columnMapping).forEach(mapping => {
    if (!result[mapping.type]) {
      result[mapping.type] = {};
    }
    if (!result[mapping.type][mapping.key]) {
      result[mapping.type][mapping.key] = [];
    }
  });

  dataRows.forEach(row => {
    Object.values(columnMapping).forEach(mapping => {
      const value = row[mapping.index];
      result[mapping.type][mapping.key].push(value !== undefined ? value : null);
    });
  });

  return result;
};
